import React from "react";
import { Route } from "react-router-dom";
import { PrivateRoute } from "../../../../PrivateRoute";
import MasterDataUserDialog from "./master-data-user-create/MasterDataUserDialog";
import { MasterDataUserCard } from "./MasterDataUserCard";
import { MasterDataUserUIProvider } from "./MasterDataUserUIContext";

export function MasterDataUserPage({ history, match }) {
  const masterDataUserEvent = {
    addNewUser: () => {
      history.push("/admin/master-data/user/create");
    },
    editUser: id => {
      history.push(`/admin/master-data/user/${id}/edit`);
    }
  };

  return (
    <MasterDataUserUIProvider masterDataUserUIEvents={masterDataUserEvent}>
      <PrivateRoute
        role={true}
        component={MasterDataUserDialog}
        path="/admin/master-data/user/create"
      />

      <PrivateRoute
        role={true}
        component={MasterDataUserDialog}
        path="/admin/master-data/user/:id/edit"
      />

      <Route
        path="/admin/master-data/user/create"
        render={({ history, match }) => (
          <MasterDataUserDialog
            show={match != null}
            onHide={() => {
              history.push("/admin/master-data/user");
            }}
          />
        )}
      />

      <Route
        path="/admin/master-data/user/:id/edit"
        render={({ history, match }) => (
          <MasterDataUserDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/admin/master-data/user");
            }}
          />
        )}
      />

      <MasterDataUserCard />
    </MasterDataUserUIProvider>
  );
}
